import { useContext } from "react";
import {
  DescriptionFieldProps,
  FormContextType,
  RJSFSchema,
  StrictRJSFSchema
} from "@rjsf/utils";
import { Text } from "@chakra-ui/react";
import { getPathOr } from "crocks";
import { FormViewerContext } from "../context";

export default function DescriptionField<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any
>({ description, id }: DescriptionFieldProps<T, S, F>) {
  const { styles } = useContext(FormViewerContext);
  const descriptionStyles = getPathOr({}, ["description"], styles);

  if (!description || description === "<empty_value>") {
    return null;
  }

  if (typeof description === "string") {
    return (
      <Text id={id} mt={2} mb={4} {...descriptionStyles}>
        {description}
      </Text>
    );
  }

  return <>{description}</>;
}
